import { useState, ReactNode } from 'react';
import { useIsMountedRef } from 'utils/hooks';

import Typography from 'components/atoms/Typography';

import { ButtonStyleType } from 'utils/frontendTypes';
import ModalWrapper, { ModalFooter } from './ModalWrapper';

export interface ConfirmationModalProps {
  text?: ReactNode;
  title?: string;
  onConfirm: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmButtonType?: ButtonStyleType;
  cancelButtonType?: ButtonStyleType;
  onCancel?: () => void;
  disableDismiss?: boolean;
}

function ConfirmationModal(props: ConfirmationModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useIsMountedRef();
  return (
    <ModalWrapper disableDismiss={props.disableDismiss}>
      <Typography className="pt-10 mb-5 text-center text-glooCharcoal" variant="h1">
        {props.title || 'Are you sure?'}
      </Typography>
      <Typography variant="base" className="flex flex-col pb-5 text-sm text-center md:mx-20 text-glooMedGray">
        {props.text}
      </Typography>
      <ModalFooter
        isLoading={isLoading}
        primary={{
          text: props.confirmButtonText || 'Confirm',
          type:
            props.confirmButtonType ||
            (props.confirmButtonText?.toLowerCase().includes('delete') ? 'destruction' : 'primary'),
          autoFocus: true,
        }}
        secondary={{
          text: props.cancelButtonText || 'Cancel',
          type: props.cancelButtonType || 'tertiary',
        }}
        onCancel={props.onCancel || undefined}
        onConfirm={async () => {
          try {
            setIsLoading(true);
            if (props.onConfirm) {
              await props.onConfirm();
            }
          } finally {
            if (isMountedRef.current) {
              setIsLoading(false);
            }
          }
        }}
      />
    </ModalWrapper>
  );
}

export default ConfirmationModal;
